import React from 'react';
import '../style/Header.css';

const Header = () => {
    return ( 
        <>
            <div className='headerText'>
                <h1><b>KMP Deterministic Finite State Automaton Visualization</b></h1>
                <h3>Inspired by COMP582 @ Rice University</h3>
            </div>
		</>
     );
}
 
export default Header;
<></>